// extracted by mini-css-extract-plugin
export default {"afterpayBtnWrapper":"A7-z","button":"B7-z","disabled":"C7-z","creditCard":"D7-z","wrapper":"E7-z"};